import { Box, Container } from "@chakra-ui/react"
import { createSampleFlashcard } from "@pathwright/blocks-core/src/blocks/flashcards/block-type"
import { EDITOR_MODE } from "@pathwright/blocks-engine"
import { List } from "@pathwright/blocks/src/shared"
import sortBy from "lodash/sortBy"
import { useCallback, useMemo } from "react"
import "../Cards/sortable-styles.css"
import { CardFace } from "./CardFlipper"
import Flashcard from "./Flashcard"
import FlashcardAdd from "./FlashcardAdd"

const CARD_SIZE = 250

const FlashcardsContainer = (props) => {
  const { data, onChange, mode, id: blockID } = props

  const { flashcards = [] } = data

  const handleGenerateItem = useCallback(
    ({ order }) => {
      return createSampleFlashcard(order)
    },
    [createSampleFlashcard]
  )

  const handleChange = useCallback(
    ({ items }) => {
      onChange({ flashcards: items })
    },
    [onChange]
  )

  const renderItem = useCallback(
    ({ item, index, DragHandle, onRemove, onUpdate }) => {
      const handleUpdateContent = (sideName, property, value) => {
        const update = Array.isArray(property)
          ? property.reduce((acc, prop, i) => {
              acc[prop] = value[i]
              return acc
            }, {})
          : { [property]: value }

        onUpdate({
          attribute: sideName,
          value: {
            ...item[sideName],
            ...update
          }
        })
      }

      return (
        <Flashcard
          flashcard={item}
          cardIndex={index}
          updateContent={handleUpdateContent}
          onRemoveFlashcard={onRemove}
          DragHandle={DragHandle}
          mode={mode}
          blockID={blockID}
        />
      )
    },
    [mode]
  )

  const renderAdd = useCallback(
    ({ onAdd }) => {
      return (
        <CardFace
          pos="relative"
          h={CARD_SIZE}
          shadow="none"
          p={1}
          borderRadius="0"
          bg="transparent"
        >
          <FlashcardAdd addFlashCard={onAdd} />
        </CardFace>
      )
    },
    [CARD_SIZE]
  )

  const generateItem = useMemo(
    () => (mode === EDITOR_MODE.EDIT ? handleGenerateItem : null),
    [mode]
  )
  const passRenderAdd = useMemo(
    () => (mode === EDITOR_MODE.EDIT ? renderAdd : null),
    [mode]
  )

  return (
    <Container w="80%" m="0 auto" maxW="1000px" p="0">
      {/* TODO: remove List container at some point (or convert it to Chakra) */}
      <Box
        css={{
          "& .ListItemContainer": {
            display: "grid",
            gridTemplateColumns: `repeat(auto-fit, minmax(${CARD_SIZE}px, ${CARD_SIZE}px))`,
            gridGap: 4,
            h: "full",
            w: "full",
            flexGrow: 1,
            justifyContent: "center",
            alignItems: "center",
            perspective: "10000000px"
          }
        }}
      >
        <List
          generateItem={generateItem}
          renderAdd={passRenderAdd}
          items={sortBy(flashcards, "order")}
          direction="grid"
          min={1}
          renderItem={renderItem}
          inlineAdd={true}
          onChange={handleChange}
          id={props.id || "blocks-flashcards"}
        />
      </Box>
    </Container>
  )
}

export default FlashcardsContainer
